import React from 'react';
import { QuoteLineItemProps } from '@partsbadger/types';
import { MultipleQuantitiesPrices } from '../../MultipleQuantitiesPrices';

interface IProps {
    lineItem: QuoteLineItemProps;
    quantitySelector?: React.ReactNode;
}

/**
 * Single-quantity pricing uses the same grouped price selector as
 * multiple-quantity pricing. Passing one item simply renders one quantity
 * group, while preserving the same selection/update behavior and visual
 * language in both modes.
 */
const LeadTimeOptions: React.FC<IProps> = ({ lineItem, quantitySelector }) => (
    <MultipleQuantitiesPrices items={[lineItem]} quantitySelector={quantitySelector} />
);

export default LeadTimeOptions;
